import {Box, CircularProgress, Typography, useTheme} from '@mui/material';

import {Colors} from '../common/colors';
import {HistoryButton} from '../common/button';
import Link from 'next/link';
import { NewsWithCampaignInfo } from '../../types';
import { getLocaleLabels } from '../../utils/lang';
import { useGetLatestNews } from '../../queries/newsQueries';
import {useTranslation} from 'next-i18next';

// import ForwardRoundedIcon  from '@mui/icons-material/ForwardRounded';

type HistoryProps = {
    withoutActiveCampaign?: boolean;
};

export default function History(props: HistoryProps) {
    if (props.withoutActiveCampaign) {
        return <HistoryWithoutActiveCampaign />;
    } else {
        return <HistoryWithActiveCampaign />;
    }
}

function HistoryWithActiveCampaign() {
    const {t} = useTranslation('common');
    return (
        <Box
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: 5,
                paddingRight: 5,
                marginBottom: 10,
                alignSelf: 'center',
                width: '100%',
                maxWidth: {xl: '1280px', md: '640px', sx: '640px'},
            }}
        >
            <Box sx={{alignSelf: {sx: 'center', md: 'flex-end'}}}>
                <HistoryButton href="/history">{t('action.go_to_history')}</HistoryButton>
            </Box>
        </Box>
    );
}

function HistoryWithoutActiveCampaign() {
    const {t} = useTranslation('common');
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                alignSelf: 'center',
                maxWidth: 500,
                flexDirection: 'column',
                marginLeft: 3,
                marginRight: 3,
                padding: {xs: 4, md: 6},
                marginBottom: 10,
                marginTop: {xs: 4, md: 0},
                backgroundColor: theme.palette.background.default,
                borderRadius: '8px',
                WebkitBoxShadow: Colors.shadow,
                boxShadow: Colors.shadow,
            }}
        >
            <Box sx={{marginBottom: 6}}>
                <Typography sx={{textAlign: 'center', fontSize: 20, fontWeight: 'bold'}}>
                    {t('title.no_campaign')}
                </Typography>
                <Typography
                    sx={{marginTop: 3, fontSize: 16, maxWidth: 400, textAlign: 'center'}}
                >
                    {t('advertisement.no_campaign')}
                </Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                }}
            >
                <HistoryButton href="/history">{t('action.go_to_history')}</HistoryButton>
            </Box>
            <LatestNewsSection />
        </Box>
    );
}

function LatestNewsSection(){
    const {data, isLoading} = useGetLatestNews();
    if (isLoading) {
        return <CircularProgress />
    }
    return <NewsSection news={data} />;
}


function NewsSection(props: {news: NewsWithCampaignInfo}){
    const theme = useTheme();
    const {t, i18n} = useTranslation('common');
    const newsLabels = getLocaleLabels(props.news.labels, i18n.language);
    const campaignLabels = getLocaleLabels(props.news.campaign.labels, i18n.language);

    const campaignSlug = props.news.campaign.url;
    const newsId = props.news.news_id;

    const newsUrl = `/${i18n.language}/${campaignSlug}?tab=news#${newsId}`

    return <Box sx={{mt: 3}}>
        <Link href={newsUrl}  style={{textDecoration: 'none', color: 'inherit'}}>
            <Box sx={{backgroundColor: theme.palette.backgroundLight.main, display: 'flex', flexDirection: 'column', padding: 2, marginTop: 2, justifyContent: 'center', alignItems: 'center', borderRadius: 2, py: 3}}>
                <Typography sx={{textAlign: 'center', fontSize: 14, fontVariant: 'small-caps', textTransform: 'lowercase'}}>
                    {t('title.latest_news')}
                </Typography>
                <Typography sx={{textAlign: 'center', fontWeight: 'bold', fontSize: 16, my: 2}}>
                    {campaignLabels.title}
                </Typography>
                <Typography sx={{my: 2}}>
                    {newsLabels.title}
                </Typography>
                <Link href={newsUrl} style={{textDecoration: 'none', color: Colors.first, fontWeight: 'bold'}}>
                    {t('link.read_latest_news')}
                </Link>
            </Box>
        </Link>
    </Box>
}